import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum NotificationProgressStatus {
  InProgress = 'inProgress',
  Done = 'done',
  Error = 'error',
}

export type NotificationState = {
  showProgress: boolean;
  progress: number;
  message: string;
  progressStatus: NotificationProgressStatus;
};

const initialState: NotificationState = {
  showProgress: false,
  progress: 0,
  message: '',
  progressStatus: NotificationProgressStatus.InProgress,
};

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    showNotification: (state, action: PayloadAction<boolean>): void => {
      state.showProgress = action.payload;
    },
    setNotificationProgress: (state, action: PayloadAction<number>): void => {
      if (
        state.progressStatus === NotificationProgressStatus.InProgress ||
        !!state.showProgress
      ) {
        state.progress = action.payload;
      }
    },
    setNotificationMessage: (state, action: PayloadAction<string>): void => {
      state.message = action.payload;
    },
    setNotificationProgressStatus: (
      state,
      action: PayloadAction<NotificationProgressStatus>,
    ): void => {
      state.progressStatus = action.payload;
    },
    setNotification: (state, action: PayloadAction<Partial<NotificationState>>): void => {
      Object.assign(state, action.payload);
    },
  },
});

export const {
  showNotification,
  setNotificationProgress,
  setNotificationMessage,
  setNotificationProgressStatus,
  setNotification,
} = notificationSlice.actions;

export default notificationSlice.reducer;
